import "./styles.less";

import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Space, Table, Typography } from "antd";


const { Column } = Table;

export interface PricingTableProps {
	dataSource: dataSourceType[];
	rowItems: rowItemsType;
}

interface dataSourceType {
	name: string;
	[x: string]: string | number | boolean;
}
interface rowItemsType {
	name: string;
	[x: string]: string;
}

export const PricingTable = ({ dataSource, rowItems }: PricingTableProps) => {

	const data = Object.keys(rowItems)
		.filter(e => e != "name")
		.map((e, i) => {
			let row_data = { key: i, rowText: rowItems[e] };
			dataSource.forEach((col, index) => (row_data[index] = col[e]));
			return row_data;
		});

	const TableHeader = title => {
		return (
			<Space direction={"vertical"} size={0} className={"header-text"}>
				<Typography.Text strong className="text-plan">
					{"Plan"}
				</Typography.Text>
				<Typography.Paragraph strong className="text-title" ellipsis={{ rows: 2 }}>
					{title}
				</Typography.Paragraph>
			</Space>
		);
	};

	return (
		<Table
			dataSource={data}
			pagination={false}
			size={"small"}
			bordered={false}
			className="pricing-table">
			<Column
				title={null}
				dataIndex={"rowText"}
				key={"rows_text"}
				className={"pricing-column-first"}
				render={text => (
					<Typography.Paragraph strong style={{ margin: 0 }} ellipsis={{ rows: 2 }}>
						{text}
					</Typography.Paragraph>
				)}
			/>
			{dataSource.map((plan, i) => {
				return (
					<Column
						title={TableHeader(plan.name)}
						dataIndex={i}
						key={"plan" + i}
						className={"pricing-column"}
						ellipsis={{ showTitle: false }}
						render={text => {
							if (typeof text == "boolean") {
								return (
									<div className={"boolean-entry " + text}>
										{text ? <CheckOutlined /> : <CloseOutlined />}
									</div>
								);
							}
							return text;
						}}
					/>
				);
			})}
		</Table>
	);
};
